<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="border-radius: 16px; width: 250px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >STORE & PRODUCT</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <v-list-group
          v-for="item in filteredSidebar"
          v-model="item.active"
          :key="item.title"
          :prepend-icon="item.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="subItem.url"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      items: [
        {
          action: "store",
          permission_name: "store_list",
          title: "Store",
          items: [
            {
              title: "Store List",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/storeandproduct/storemanage",
            },
            {
              title: "Store Type List",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/storeandproduct/storetypelist",
            },
            {
              title: "Store Service List",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/storeandproduct/storeservicelist",
            },

            // {
            //   title: 'Store Recommended',
            //   url:  '/weserve_admin_login/control/' + this.$store.state.backOffice.province + '/storeandproduct/storerecommended'
            // }
          ],
        },
        {
          action: "star",
          permission_name: "order_store_review",
          title: "Review",
          items: [
            {
              title: "Order Review",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/storeandproduct/orderstorereview",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
    filteredSidebar() {
      return this.items.filter((val) => {
        for (let val2 in this.permission.store_and_product) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
};
</script>

